import { Asset } from './asset.model'
import { User } from './user.model'
import { Device } from './device.model'
import { AbstractVehicle } from './vehicle.model'
import { Team } from './team.model'

export interface DeviceSensor {
  id: number
  deviceId: number
  vehicleId: number
  sensor: Sensor
  lastTrackerHistorySensor: LastTrackerHistorySensor
  createdAt: string
  createdBy: User
  updatedAt: string
  trackerHistoriesSensor: SensorTrackerHistory[]
  isAutoCreated: boolean
  sensorId: string
  label: string
  type: SensorType
  team: Team
}

export interface Sensor {
  createdAt: string
  createdBy: string
  id: number
  isAutoCreated: boolean
  label: string
  sensorId: string
  type: SensorType
  updatedAt: string
  updatedBy: string
  asset: Asset
  team: Team
  lastTrackerHistorySensor?: LastTrackerHistorySensor
  systemStatus: SensorStatus
}

export interface SensorType {
  id: number
  name: string
  label: string
}

export interface SensorTrackerHistory {
  batteryPercentage: number
  humidity: number
  id: number
  lastPosition: any
  light: number
  occurredAt: string
  status: boolean
  temperature: number
  value: string
  vehicleId: number
}

export type InputSensor = Pick<Sensor, 'sensorId' | 'type' | 'label'> & { teamId?: number }

export interface SensorDeviceInstance extends Sensor {
  device: Device
  vehicle: AbstractVehicle
}

export interface LastTrackerHistorySensor {
  deviceId: number
  deviceSensorBleId: string
  deviceSensorId: number
  deviceSensorLabel: string
  humidity: number
  id: number
  occurredAt: string
  rssi: number
  status: boolean
  temperature: number
  value: string
  light?: number
  batteryPercentage?: number
}

export enum SensorTypeIds {
  IButton = 1,
  TemperatureAndHumidity = 2,
  TrackingBeacon = 3,
}

export enum SensorStatus {
  Active = 'active',
  Archived = 'archive',
}
